import { Card, CardBody, Col, Row } from "reactstrap";
import { BordersAndDisplays } from "../../../../Constant";
import { BORDER_DATA } from "../../../../Data/UiKit/HelperClasses";
import { AdditiveBorders } from "./AdditiveBorder";
import { SubtractiveBorders } from "./SubtractiveBorder";
import { AdditiveRadius } from "./AdditiveRadius";
import CommonCardHeader from "../../../../Common/CommonCardHeader";

const BorderCart = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={BordersAndDisplays} span={BORDER_DATA}/>
        <CardBody>
          <Row className="g-3">
            <AdditiveBorders />
            <SubtractiveBorders />
            <AdditiveRadius />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BorderCart;
